import * as _ from "lodash";
import { GeoPoint } from "./geoPoint";
import { GeoPolygon } from "./geoPolygon";

export class GeoPolygonList {
    constructor(public polygons: GeoPolygon[]) {
    }

    containsPoint(point: GeoPoint): boolean {
        let numContainingPolygons = _.sumBy(this.polygons, it => it.containsPoint(point) ? 1 : 0);
        return numContainingPolygons % 2 == 1;
    }

    getBiggestPolygon(): GeoPolygon {
        return _.maxBy(this.polygons, it => it.boundingBox.area)!;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/earth/core/geoPolygonList.ts